import React from 'react';
import {
  Box,
  IconButton,
  Popover,
  Tooltip,
  Typography,
} from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';

/**
 * @param {Object} props
 * @param {string} props.helpText - Texto explicativo que se muestra en el popover.
 * @param {string} [props.tooltipText] - Texto del tooltip al pasar el cursor (por defecto: "Información").
 */
export function HelpButton({ helpText, tooltipText = 'Información' }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  if (!helpText) return null;

  return (
    <>
      <Tooltip title={tooltipText}>
        <IconButton
          size="small"
          onClick={handleClick}
          style={{ padding: 4 }}
        >
          <HelpIcon style={{ color: '#7786fc', fontSize: '20px' }} />
        </IconButton>
      </Tooltip>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          style: {
            maxWidth: 360,
            backgroundColor: 'rgba(55, 55, 65, 0.95)',
            borderRadius: '10px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
          },
        }}
        disableScrollLock
      >
        <Box padding={2}>
          <Typography
            variant="body2"
            style={{
              color: 'white',
              lineHeight: 1.6,
              fontSize: '0.85rem',
            }}
          >
            {helpText}
          </Typography>
        </Box>
      </Popover>
    </>
  );
}
